export enum DomSanitizerEnum {
  SafeHtml = 1,
  SafeStyle,
  SafeScript,
  SafeUrl,
  SafeResourceUrl
}

export enum ScamAlertSeenEnum {
  Seen = 0,
  Unseen
}
